<mat-select [matMenuTriggerFor]="menu" [placeholder]="selectionSummary$ | async">
  <!--
    NOTE: I'm abusing mat-selct here, I just want it for the placeholder/dropdown styling
  -->
</mat-select>
<mat-menu #menu="matMenu">
  <div class="quantity-option" *ngFor="let option of options$ | async">
    {{ option.label }}
    <span class="quantity-option__toggle">
      <mat-icon class="quantity-option__decrement" (click)="decrement($event, option.value)"
        >remove</mat-icon
      >{{ option.count }}
      <mat-icon class="quantity-option__increment" (click)="increment($event, option.value)"
        >add</mat-icon
      >
    </span>
  </div>
</mat-menu>
